import RenderComponent from './RenderComponent';

export default RenderComponent;
